module.exports = __webpack_public_path__ + "static/media/rocketShip.84c83eb8.png";